import { Component, OnInit } from '@angular/core';
import { CommonService, ModalService, BoothService } from './services';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

import boothData from './data/booths.json';
import { BoothItem } from './models';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public showSplash: boolean = false; // __DEBUG - true shows only the splash page, false shows the entire experience
    public debug = false;
    public boothDataLoaded = false;
    public initialLoad = true;
    public boothToNavigate = undefined;

    constructor(
        private modalSvc: ModalService,
        private commonSvc: CommonService,
        private boothSvc: BoothService,
        private router: Router,
    ) {

        router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                // this.popStateEventOccured = (val.navigationTrigger === 'popstate');
            }

            if (val instanceof NavigationEnd) {
                console.log(
                    'NavigationEnd', val
                )
                const data: BoothItem = boothData.booths.find((el: BoothItem) => el.url === val.url);

                if (val.urlAfterRedirects === '/medical-info') {
                    this.commonSvc.setMedInfoLink();
                    this.router.navigateByUrl('/');
                    return;
                }

                if (data) {
                    if (this.initialLoad) {
                        this.initialLoad = false;
                        this.boothToNavigate = data.id;
                    }
                    //  else {
                    //     if (this.popStateEventOccured && val.url === '/medical-info') {
                    //         this.modalSvc.setActiveModalById('leaving-medical');
                    //     } else {
                    //         this.stateSvc.setState(data.id);
                    //         this.modalSvc.hideModal();
                    //     }
                    // }
                }
            }
        });
        this.commonSvc.initLogs();

        this.boothSvc.boothDataUpdated.subscribe(data => {
            console.log('boothDataUpdated ', data)
            this.boothDataLoaded = data;

        });
        this.boothSvc.setUpBoothData();
        this.debug = this.commonSvc.debug.value;
    }
    public waitForData(): void {

    }

    ngOnInit(): void {
        let gated = localStorage.getItem(`${environment.showName}-gated`);
        let showGate = true;
        if (gated) {
            // If the user as gated on this config more than a day ago gate them again.
            const time = new Date();
            const timeDiff = time.getTime() - new Date(gated).getTime();
            const days = timeDiff / (1000 * 3600 * 24);
            showGate = (days > 1);
        } // END IF

        if (showGate) {
            this.modalSvc.setActiveModalById('welcome');
        }
        window.addEventListener('houdiniEvent', this.checkForAcquire.bind(this));

    }

    checkForAcquire(e): void {
        console.log("Checking for acquire", e);
        if (e.detail.acquireReady) {
            this.commonSvc.setAcquireReady(true);
        }
    }

}
